import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import type { Widgets } from '@common/enums';

import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { TranslateModule } from '@ngx-translate/core';

/**
 * The hover controls of a widget.
 *
 * Every other entity has its own component now — `web-default-block-controls`,
 * `web-zero-block-controls`, `web-specific-block-controls`,
 * `web-shared-block-controls`, `web-default-column-controls`,
 * `web-grid-controls` — because reordering, pinning, the gallery, the
 * locked-delete hint and the grid's "Structure" dropdown all lived here behind
 * flags that every caller but one switched off.
 */
@Component({
    selector: 'web-item-controls',
    templateUrl: './item-controls.component.html',
    styleUrls: ['./item-controls.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [BsDropdownModule, TooltipModule, TranslateModule],
})
export class ItemControlsComponent {
    /** The widget this dresses, and the only thing that shifts the dropdown's anchor. */
    @Input() public widgetName: Widgets;

    /** A logo, the cart icon, or a widget the plan's product limit locks. */
    @Input() public disableCopyEvent: boolean;
    @Input() public disableRemoveEvent: boolean;

    @Input() public selectActionTooltip: string;

    @Output() public deleteEvent: EventEmitter<void> = new EventEmitter<void>();
    @Output() public copyEvent: EventEmitter<void> = new EventEmitter<void>();
    @Output() public selectEvent: EventEmitter<void> = new EventEmitter<void>();
    @Output() public toggleMoreActionState: EventEmitter<boolean> = new EventEmitter<boolean>();

    public deleteAction(): void {
        if (this.disableRemoveEvent) {
            return;
        }

        this.deleteEvent.emit();
    }

    public copyAction(): void {
        if (this.disableCopyEvent) {
            return;
        }

        this.copyEvent.emit();
    }

    public selectAction(): void {
        this.selectEvent.emit();
    }

    public isShowDropDownMenu(state): void {
        this.toggleMoreActionState.emit(state);
    }
}
